
export type ExploreContentItemBasicInfoAllOfTwoType = typeof ExploreContentItemBasicInfoAllOfTwoType[keyof typeof ExploreContentItemBasicInfoAllOfTwoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExploreContentItemBasicInfoAllOfTwoType = {
  TWEET: 'TWEET',
  TOPIC: 'TOPIC',
  PROJECT: 'PROJECT',
} as const;
